import { render, staticRenderFns } from "./RelatedPublications.vue?vue&type=template&id=30baec97&scoped=true&"
import script from "./RelatedPublications.vue?vue&type=script&lang=js&"
export * from "./RelatedPublications.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPublications.vue?vue&type=style&index=0&id=30baec97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30baec97",
  null
  
)

export default component.exports